import React from 'react';
import { Box } from '@mui/material';

export const SectionDelimiter = () => {
  return (
    <Box sx={{
      width: '110px',
      height: '1px',
      backgroundColor: '#F3F3F3',
    }}/>
  );
};
